import React from 'react';
import { useTranslation } from 'react-i18next';
import Box from '../../shared/atoms/Box';
import Text from '../../shared/atoms/Text';
import Badge from '../../shared/atoms/Badge';
import Button from '../../shared/atoms/Button';
import Separator from '../../Separator';
import { horaireLong, majuscule } from '../../../annuaire/tunnel/creneaux';
import {
  messageThreadStatusKey,
  messageThreadStatusColor,
} from '../../../utils/messageThreadStatus';

/**
 * FIXERLIGHT-049 — une ligne de la liste « Mes messages ».
 *
 * `ClientMessageThreadResource` (contrat § 4) n'expose PAS de dernier
 * message ni son horodatage sur la liste — `index()`
 * (`ClientMessageThreadController`) ne charge jamais la relation
 * `messages`, et `whenLoaded('messages', …)` retire alors la clé du JSON.
 * Une carte ne peut donc montrer que l'atelier, le statut et la date
 * d'ouverture, pas d'extrait du dernier message — assumé, l'api fait foi.
 */
const MessageThreadCard = ({ thread }) => {
  const { t } = useTranslation();
  const statusKey = messageThreadStatusKey(thread.status);

  return (
    <Box
      borderColor="gray.light"
      borderWidth="1px"
      borderRadius="sm"
      borderStyle="solid"
      mb={5}
      p={{ xs: 2, lg: 5 }}
      data-testid="message-thread-card">
      <Box
        flexDirection="row"
        flexWrap="wrap"
        justifyContent="space-between"
        style={{ rowGap: 8 }}>
        <Text color="black">{thread.shop && thread.shop.name}</Text>
        {statusKey && (
          <Badge color={messageThreadStatusColor(thread.status)} light>
            {t(statusKey)}
          </Badge>
        )}
      </Box>
      <Separator mt={4} axe="horizontal" />
      <Box
        flexDirection={{ xs: 'column', lg: 'row' }}
        justifyContent="space-between"
        alignItems={{ xs: 'stretch', lg: 'center' }}
        pt={{ xs: 2, lg: 0 }}>
        <Text>
          {t('messages.card.opened', {
            date: majuscule(horaireLong(thread.opened_at)),
          })}
        </Text>
        <Box mt={{ xs: 3, lg: 0 }}>
          <Button fullWidth variant="filled" to={`/messages/${thread.id}`}>
            {t('seedetails')}
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default MessageThreadCard;
